import React from 'react'
import { navigate } from 'gatsby'
import { BiBuildingHouse } from 'react-icons/bi'
import { ChevronDownIcon } from '@chakra-ui/icons'
import { Divider, Flex, Text } from '@chakra-ui/react'
import { Menu, MenuButton, MenuList } from '@chakra-ui/react'

import UserOptions from './user-options'
import ClinicOptions from './clinic-options'
import { useClinic } from '~contexts/clinic-context'
import { useUserContext } from '~config/user-context'
import ClinicGroupOptions from './clinic-group-options'
import SharedStack from '~components/shared/wrappers/shared-stack'
import UrgentIcon from '~components/shared/icons/urgent-icon'
import { getHasPermissions } from '~utils/helpers'
import { AdminPermissionFeature } from '~graphql/generated/graphql'
import { formatClinicName } from '~utils/helpers'
import { UserRoutes } from '~config/routes'
import MenuItem from '~components/shared/menu/menu-item'

export default function AccountButton() {
    const { user, isEmailVerified } = useUserContext()
    const {
        clinic,
        setClinic,
        hasMultipleClinics,
        clinicGroup,
        setClinicGroup,
        permissions,
    } = useClinic()

    const canEditClinicInfo = getHasPermissions(
        permissions,
        AdminPermissionFeature.ClinicInfo,
    )

    return (
        <Menu placement="bottom-end">
            <MenuButton role="group">
                <SharedStack row fit rounded="md" px={2} cursor="pointer">
                    <Flex flexDir="column" align="flex-end">
                        <Text
                            fontSize="xs"
                            fontWeight="semibold"
                            color={
                                clinic || clinicGroup ? 'gray.900' : 'gray.700'
                            }
                            fontStyle={
                                clinic || clinicGroup ? 'none' : 'italic'
                            }
                            noOfLines={1}
                        >
                            {formatClinicName(clinic?.name) ||
                                formatClinicName(clinicGroup?.name) ||
                                'Select a Clinic'}
                        </Text>
                        <SharedStack row fit spacing={2}>
                            {!isEmailVerified && <UrgentIcon fontSize="xs" />}
                            <Text
                                noOfLines={1}
                                fontSize="11px"
                                color="gray.500"
                                transition="color 0.1s ease-out"
                                _groupHover={{
                                    color: 'gray.900',
                                }}
                            >
                                {user?.first_name + ' ' + user?.last_name}
                            </Text>
                        </SharedStack>
                    </Flex>
                    <ChevronDownIcon color="gray.900" />
                </SharedStack>
            </MenuButton>
            <MenuList px={0} w="356px" rounded="2xl" zIndex={1000}>
                {clinic && (
                    <ClinicOptions
                        clinic={clinic}
                        setClinic={setClinic}
                        setClinicGroup={setClinicGroup}
                        isClinicAdmin={canEditClinicInfo}
                        canSwitch={hasMultipleClinics}
                    />
                )}
                {clinicGroup && (
                    <ClinicGroupOptions
                        clinicGroup={clinicGroup}
                        setClinicGroup={setClinicGroup}
                        setClinic={setClinic}
                        canSwitch={hasMultipleClinics}
                    />
                )}
                {!clinic && !clinicGroup && (
                    <MenuItem
                        icon={BiBuildingHouse}
                        onClick={() => navigate(UserRoutes.SelectClinic)}
                    >
                        Select Clinic / Group
                    </MenuItem>
                )}
                <Divider my={2} />
                {user && (
                    <UserOptions
                        user={user}
                        setClinic={setClinic}
                        setClinicGroup={setClinicGroup}
                    />
                )}
            </MenuList>
        </Menu>
    )
}
